import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BuildingHutsIdResponseModel } from './models/buildingHutsId.response.model';

@Injectable({
    providedIn: 'root'
})
export class BuildingSearchService {

    buildingDetailsSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    buildingDetails$: Observable<any> = this.buildingDetailsSubject.asObservable();
    baseUrlBuildingIdDetails = environment.baseUrlBuildingIdDetails;

    isBuildingNotSelectedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    isBuildingNotSelected$: Observable<boolean> = this.isBuildingNotSelectedSubject.asObservable();


    constructor(
        private http: HttpClient
    ) {
    }

    getBuildingDetailsById(buildingHutsId: number) {
        return this.http.get<BuildingHutsIdResponseModel[]>(this.baseUrlBuildingIdDetails + '/' + buildingHutsId);
    }

    getBuildingId(address) {
        return this.http.post<BuildingHutsIdResponseModel[]>(this.baseUrlBuildingIdDetails, address);
    }

    getBuildingDetailsForAdvancedSearch(searchBody) {
        return this.http.post<BuildingHutsIdResponseModel[]>(this.baseUrlBuildingIdDetails + '/legacy', searchBody);
    }
}
